import { z } from "zod";
import { AD_PRODUCT_CHOICE_KEY } from "./AdProductChoiceKey";

const AD_PRODUCT_CHOICE = z.object({
  key: AD_PRODUCT_CHOICE_KEY,
  timestamp: z.date(),
});

export const AD_PRODUCT_PENDING_CHOICE = AD_PRODUCT_CHOICE.extend({
});

export const AD_PRODUCT_PURCHASED_CHOICE = AD_PRODUCT_CHOICE.extend({
  cost: z.number().min(0),
});

export type AdProductPendingChoice = z.infer<typeof AD_PRODUCT_PENDING_CHOICE>;
export type AdProductPurchasedChoice = z.infer<
  typeof AD_PRODUCT_PURCHASED_CHOICE
>;

export type AdProductChoice = AdProductPendingChoice | AdProductPurchasedChoice;